import React from 'react';
import './InstitutionSection.css';

const InstitutionSection = () => {
  const benefits = [
    'Make confident, well-informed decisions',
    'Avoid last-minute confusion and missed opportunities',
    'Understand realistic career outcomes before choosing',
    'Compare colleges and countries objectively',
    'Plan exams, applications, and finances early',
    'Reduce dependence on rumours and unverified advice'
  ];

  return (
    <section className="section control-future-section">
      <div className="container">
        <div className="control-future-content">
          <div className="control-future-image">
            <span className="control-future-badge">Clear Direction</span>
            <img
              src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
              alt="Students collaborating and planning their future"
            />
          </div>
          <div className="control-future-text">
            <h2 className="control-future-title">
              <span className="highlight">Take</span> Control of Your <span className="highlight-orange">Future</span>
            </h2>
            <p className="control-future-subtitle">
              We help you make decisions based on facts, not pressure or guesswork.
            </p>
            <ul className="control-future-benefits">
              {benefits.map((benefit, index) => (
                <li key={index} className="benefit-item">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="benefit-icon">
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="16 9 10 15 8 13" />
                  </svg>
                  <span>{benefit}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InstitutionSection;
